import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=9e6b417c&scoped=true&"
import script from "./AnimatedButton.vue?vue&type=script&lang=ts&"
export * from "./AnimatedButton.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedButton.vue?vue&type=style&index=0&id=9e6b417c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6b417c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VHover,VIcon})
